// @flow
import type { Auction, AuctionsApiItem } from "./auction";

import { int } from "../helpers/types";

export type Viewing = {
  id: number,
  start: Date,
  end: Date,
  title: string,
  address?: string,
  country?: string,
  town?: string,
  postalCode?: string
};
export type Session = {
  id: number,
  title: string,
  catLow: number,
  catHigh: number,
  start: Date,
  end: Date
};
export type Calendar = {
  ...Auction,
  viewings: Array<Viewing>,
  sessions: Array<Session>,
  contributionEnd: Date,
  collectionEnd: Date
};

export default function modelAuction(item: AuctionsApiItem): Auction {
  return {
    id: int(item.auc_id),
    title: item.auc_title,
    active: item.auc_active_front_end,
    calendar: item.auc_show_in_calendar,
    url: item.auc_url_front_end,
    image:
      item.auc_image && item.auc_image !== "files/"
        ? `${item.auc_url_front_end}/${item.auc_image}`
        : null,
    start: new Date(item.auc_start_datetime),
    end: new Date(item.auc_end_datetime),
    viewings: item.auc_viewing_times
      ? item.auc_viewing_times.map(viewingMapper)
      : [
          viewingGuesser(new Date(item.auc_start_datetime)),
          viewingGuesser(new Date(item.auc_start_datetime))
        ],
    sessions: item.auc_sessions ? item.auc_sessions.map(sessionMapper) : [],
    contributionEnd: item.auc_contribution_until_date
      ? new Date(item.auc_contribution_until_date)
      : new Date(item.auc_start_datetime),
    collectionEnd: item.auc_collection_until_date
      ? new Date(item.auc_collection_until_date)
      : new Date(item.auc_start_datetime)
  };
}

function viewingGuesser(date) {
  return {
    id: date.getTime(),
    start: date,
    end: date,
    title: date.toDateString()
  };
}

function viewingMapper(item): Viewing {
  return {
    id: int(item.avt_id),
    start: new Date(item.avt_start_datetime),
    end: new Date(item.avt_end_datetime),
    title: item.avt_location.loc_description,
    address: item.avt_location.loc_address,
    country: item.avt_location.loc_country,
    town: item.avt_location.loc_town,
    postalCode: item.avt_location.loc_postal_code
  };
}

function sessionMapper(item): Session {
  return {
    id: int(item.ses_id),
    title: item.ses_description,
    catLow: int(item.ses_catalogue_number_start),
    catHigh: int(item.ses_catalogue_number_end),
    start: new Date(item.ses_start_datetime),
    end: new Date(item.ses_end_datetime)
  };
}



// WEBPACK FOOTER //
// ./src/redux/models/calendar.js